import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { dueBy } from '../util/case';

function usePriorityCaseTiming(
  businessStartTime: string,
  businessEndTime: string,
  isPriority: boolean,
  createdAt?: number | string
) {
  const [state, setState] = useState(
    dueBy(
      businessStartTime,
      businessEndTime,
      isPriority,
      createdAt || Date.now()
    )
  );
  useEffect(() => {
    const checkHours = () => {
      const updatedState = dueBy(
        businessStartTime,
        businessEndTime,
        isPriority,
        createdAt || Date.now()
      );
      setState(updatedState);
    };

    checkHours();

    const interval = setInterval(checkHours, 5000); // Check every 5 seconds
    return () => clearInterval(interval);
  }, [businessStartTime, businessEndTime, isPriority, createdAt]);
  return state;
}
export default usePriorityCaseTiming;
